import { type FireAnalyticsEvent } from '../../../types';

type onQuickFindOperationalArgs = {
	attributes: Record<string, any>;
	success: boolean;
	resultsType: 'preQuerySearchResults' | 'cachedResults' | 'postQuerySearchResults';
};

export const onQuickFindOperational = ({
	success,
	attributes,
	resultsType,
}: onQuickFindOperationalArgs): FireAnalyticsEvent => ({
	eventType: 'operational',
	action: success ? 'taskSuccess' : 'taskFail',
	actionSubject: 'ui',
	attributes: {
		...attributes,
		// This edition is not exact matching the need for the AutoHots
		// A follow up is to find the current primary product edition and log that.
		// Currently we only have confluence edition in the productEdition object, so logging the entire object for now.
		edition: attributes.productEdition,
		task: 'unifiedSearch',
		capability: `quickFind_${resultsType}`,
		// Confirmed with AutoHots team this is mandatory
		// and base on "Can I log this" doc, we can log this.
		// https://hello.atlassian.net/wiki/spaces/Monitoring/pages/5816497997/Vitalstats+Onboarding+contract?focusedCommentId=5864073069
		// https://hello.atlassian.net/wiki/spaces/SECURITY/pages/236070634/Can+I+Log+This
		hostname: window.location.hostname,
	},
});
